module.exports = __webpack_public_path__ + "img/zs11.8a76287b.jpg";